import api from '../../helpers/axios'
export const state = {
    exam: null,
    exams: []
};

export const getters = {
    exam: (state) => state.exam,
    exams: (state) => state.exams,
};

export const mutations = {
    setExam(state, newValue) {
        state.exam = newValue;
    },
    setExams(state, newValue) {
        state.exams = newValue;
    },
    setCourseId(state, newValue) {
        state.courseId = newValue;
    },
    setExamId(state, newValue) {
        state.examId = newValue;
    },
};
export const actions = {

    createExam(_, {data, courseId}) {
        return new Promise((resolve,reject) => {
            api.post(`/courses/${courseId}/exams` , data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    updateExam(_, { examId,courseId, data }) {
        return new Promise((resolve, reject) => {
            api.put(`/courses/${courseId}/exams/` + examId, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
   deleteExam(_,  {courseId, examId }) {
        return new Promise((resolve) => {
            api.delete(`/courses/${courseId}/exams/${examId}`).then((res) => {
                resolve(res.data.data)
            })
        });
    },

    fetchExam({ commit }, { examId }) {
        return new Promise((resolve, reject) => {
            api.get("/exams/" + examId).then((res) => {
                commit("setExam", res.data.data);
                resolve(res.data.data);
            }).catch(err => {
                reject(err);
            });
        });
    },

    fetchExams({ commit }, { name, type,courseId, description, isActive, page, limit, listType }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (name) {
            query += `name=${name}&`;
        }

        if (type) {
            query += `type=${type}&`;
        }

        if (description) {
            query += `description=${description}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get(`/courses/${courseId}/exams` + query).then((res) => {
                commit("setExams", res.data.data);
                resolve(res.data.data);
            });
        });
    }

};
